import React from "react";

import styles from "components/icon/ExclamationMark.module.scss";

export default function ExclamationMark() {
  return (
    <div className={styles.root}>!</div>
  );
}
